import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogRef } from "primeng/dynamicdialog";
import { SchoolselectorService } from "../../../schoolselector/schoolselectorservice.service";
import { DataService_NotifyRegBatch } from "../shared/data.service";

@Component({
	selector: "app-guardian-notify-batch-export",
	templateUrl: "./guardian-notify-batch-export.component.html",
	styleUrls: ["./guardian-notify-batch-export.component.css"],
})
export class GuardianNotifyBatchExportComponent implements OnInit {
	constructor(
		private notifyService: DataService_NotifyRegBatch,
		private selectService: SchoolselectorService,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService
	) {}

	ngOnInit(): void {
		this.loadOptions();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			this.School = school;
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	/////////////////////////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////////////////////////

	School: any;
	subscription: any;
	SchoolSelectShowAll: any = true;
	SchoolSelectShowAllID: any = -1;
	SchoolSelectShowAllText: any = "District";

	LoadingOptions: any = true;

	StudentActiveOption: any;
	GuardianActiveOption: any;
	lstActiveOptions: any = [];

	GuardianOption: any;
	lstGuardianOptions: any = [];

	EmailOption: any;
	lstEmailOptions: any = [];

	FormatOption: any;
	lstFormatOptions: any = [];

	LanguageOptionID: any = 1;
	lstYN: any = [
		{
			ID: 1,
			Desc: "Yes",
		},
		{
			ID: 0,
			Desc: "No",
		},
	];

	IsProcessing: any = false;

	errorMessage: any = "";

	/////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////
	// Load Data
	/////////////////////////////////////////////////////////////////////
	loadOptions() {
		this.LoadingOptions = true;

		var result = this.notifyService.GuardianRegBatchGetExportInfo();
		result.subscribe(
			(response) => {
				this.LoadingOptions = false;

				var Data: any = response;

				this.lstActiveOptions = Data.lstActiveOptions;
				this.GuardianActiveOption = this.lstActiveOptions[0];

				for (var z = 0; z < this.lstActiveOptions.length; z++) {
					var next = this.lstActiveOptions[z];

					if (next.Selected == true) {
						this.StudentActiveOption = next;
						break;
					}
				}

				this.lstGuardianOptions = Data.lstGuardianOptions;

				for (var z = 0; z < this.lstGuardianOptions.length; z++) {
					var next = this.lstGuardianOptions[z];

					if (next.Selected == true) {
						this.GuardianOption = next;
						break;
					}
				}

				this.lstEmailOptions = Data.lstEmailOptions;

				for (var z = 0; z < this.lstEmailOptions.length; z++) {
					var next = this.lstEmailOptions[z];

					if (next.Selected == true) {
						this.EmailOption = next;
						break;
					}
				}

				this.lstFormatOptions = Data.lstFormatOptions;

				for (var z = 0; z < this.lstFormatOptions.length; z++) {
					var next = this.lstFormatOptions[z];

					if (next.Selected == true) {
						this.FormatOption = next;
						break;
					}
				}
			},
			(error) => {
				this.LoadingOptions = false;
			}
		);
	}

	/////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////////////////////////////////
	onExport() {
		this.errorMessage = "";

		this.IsProcessing = true;

		var result = this.notifyService.GuardianRegBatchExport(
			this.School.SchoolID,
			this.StudentActiveOption.ID,
			this.GuardianOption.ID,
			this.GuardianActiveOption.ID,
			this.EmailOption.ID,
			this.FormatOption.ID,
			this.LanguageOptionID
		);
		result.subscribe(
			(response) => {
				this.IsProcessing = false;

				var Data: any = response[0];

				if (Data != undefined) {
					var a = document.createElement("a"); //Create <a>

					var FileName = "Notify_Export_";

					if (this.School.SchoolID > 0) {
						FileName += this.School.SchoolNumber;
					} else {
						FileName += this.School.SchoolName;
					}
					// FileName += "_" + this.StudentActiveOption.Desc;
					// FileName += "_" + this.GuardianOption.Desc;
					// FileName += "_" + this.GuardianActiveOption.Desc;
					// FileName += "_" + this.EmailOption.Desc;

					//Text tab
					if (this.FormatOption.ID == 1) {
						a.href = "data:text/plain;base64," + response[0];
						a.download = FileName + ".txt";
						a.click(); //Downloaded file
					}
					//Text comma
					else if (this.FormatOption.ID == 2) {
						a.href = "data:text/plain;base64," + response[0];
						a.download = FileName + ".txt";
						a.click(); //Downloaded file
					}
					//CSV
					else if (this.FormatOption.ID == 3) {
						a.href = "data:text/csv;base64," + response[0];
						a.download = FileName + ".csv";
						a.click(); //Downloaded file
					}
				} else {
					this.errorMessage = "Error Exporting Data";
				}
			},
			(error) => {
				this.IsProcessing = false;
			}
		);
	}

	onClose() {
		this.ref.close("close");
	}
	/////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////
	// Helpers
	/////////////////////////////////////////////////////////////////////
	IsLoading() {
		return this.LoadingOptions == true || this.IsProcessing == true;
	}

	/////////////////////////////////////////////////////////////////////
}
